// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseLayout_wrapper__7gTue","visualEditorWrapper":"BaseLayout_visualEditorWrapper__a4fpk","body":"BaseLayout_body__6_Hry"};